// extracted by mini-css-extract-plugin
export default {"parameter":"pXpkG","name":"sQc4f","imageWrapper":"JARQV","title":"WQwzM","description":"ycrXD"};